import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { CheckSquare, People, PeopleFill, Person, PersonFill, Square } from 'react-bootstrap-icons'
import { FaUserMd } from 'react-icons/fa'
import { useParams } from 'react-router-dom'
import DateTimePickerFunctions from '../../../../components/ui/calendar/date_picket/DateTimePickerComponents/DateTimePickerFunctions'
import Authentication from '../../../../libs/api/services/Authentication'
import Team from '../../../../libs/api/services/Team'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'

export default function PatientProfileTeams({ PatientId }) {
    const { id } = useParams()
    const teamRef = useRef()
    const [loading, setLoading] = useState(true)
    const [full, setFull] = useState(true)
    const [teams, setTeams] = useState([])
    const [facilityTeams, setFacilityTeams] = useState([])
    const { showToast, showError, showConfirm } = useContext(CommonFunctionsContext)

    useEffect(() => {
        const load = async () => {
            setTeams(await Team.ListPatientAssignments(PatientId ? PatientId : id, Authentication.getFacility()).catch(showError))
            setFacilityTeams(await Team.GetFacilitiesTeams().catch(showError))
            setLoading(false)
        }


        load()
    }, [])

    const _handleAssign = () => {
        showConfirm({
            onCancel: () => { },
            onConfirm: () => {
                Team.AssignPatient(teamRef.current.value, PatientId ? PatientId : id)
                    .then(res => setTeams([...teams, res])).catch(showError)
                // alert('Assigning:' + teamRef.current.value)
            },
            title: `Assign patient to`,
            heading: `Assign patient to`,
            children: <div>
                <select
                    ref={teamRef}
                    // onChange={e => setTeam(e.target.value)}
                    placeholder='Team'
                    className='form-control'>
                    <option></option>
                    {facilityTeams && facilityTeams.map(xTeam => <option value={xTeam.id} key={xTeam.id}>{xTeam.teamName}</option>)}

                </select>
            </div>,
            options: {
                cancel: 'Cancel',
                confirm: 'Assign'
            }

        })
        // createModal(<AssignTo onAssign={team => setTeams([...teams, team])} />, `Assign patient to`, <PersonPlus />)
    }

    const _handleRemove = (teamId, assignmentId, currentStatus) =>
        currentStatus === "Assigned" ?
            Team.RevokePatient(teamId, PatientId ? PatientId : id)
                .then(res => {
                    const _teams = [...teams]
                    var el = _teams.find(a => a.id === assignmentId)
                    // _teams.splice(_teams.indexOf(el), 1)
                    // console.log('_handleRemove', el)
                    el.currentStatus = "Revoked"
                    setTeams([..._teams])
                    showToast(`Patient has been marked as no longer being treated by team ${res.team.teamName}`, <FaUserMd />, 7)
                }).catch(showError)
            :
            Team.AssignPatient(teamId, PatientId ? PatientId : id)
                .then(res => {
                    const _teams = [...teams]
                    var el = _teams.find(a => a.id === assignmentId)
                    // _teams.splice(_teams.indexOf(el), 1)
                    el.currentStatus = "Assigned"
                    setTeams([..._teams])
                    showToast(`Patient has been marked as no longer being treated by team ${res.team.teamName}`, <FaUserMd />, 7)
                }).catch(showError)

    return (loading ?
        <div className='d-flex flex-grow-1 flex-column align-items-center justify-content-center'>
            <FontAwesomeIcon icon={faSpinner} size={'4x'} spin />
            <b className='p-3'>Loading Patient's Team Allocations</b>
        </div> :
        <>
            <div className='flex-shrink-1'>
                <h2 className='text-center m-2'>Patient is currently being treated by</h2>
            </div>
            <div className='flex-grow-1' style={{ overflow: 'auto' }}>
                {/* <div className={`d-flex justify-content-end`}>
                    <button onClick={() => setFull(!full)} className={`btn ${full && 'bg-primary-container'} `}><ClockHistory /> {`${full ? 'Hide' : 'Show'} full history`}</button>
                </div> */}
                {teams && teams.filter(f => !full ? f.currentStatus === 'Assigned' : true).map((team, idx) => <TeamLineItem team={team} onRemove={status => _handleRemove(team.team.id, team.id, status)} />)}
            </div>
            <div className='text-center m-2 flex-shrink-1'>
                <button onClick={() => _handleAssign()} className='btn bg-primary-container'>Assign patient to team</button>
            </div>
        </>
    )
}
const TeamLineItem = ({ team, onRemove }) => {
    const [show, setShow] = useState(false)
    return (
        <>
            <div className='d-flex m-2 row'>
                <div className='col-12 col-xl-2'><b>{team.team.teamName}</b></div>
                <div className='col-12 col-xl-2'>{team.currentStatus}</div>
                <div className='col-12 col-xl-2'>{DateTimePickerFunctions.LocalISO(new Date(team.created.substring(0, 19)), 'h')}</div>
                <div className='col-12 col-xl-2'>{DateTimePickerFunctions.LocalISO(new Date(team.lastUpdate.substring(0, 19)), 'h')}</div>
                <div onClick={_ => onRemove(team.currentStatus)} className='col-12 col-xl-3 btn p-0 m-0 text-start'>
                    {
                        team.currentStatus === "Assigned" ? <div><CheckSquare className='me-2' />No longer treating patient?</div>
                            : <div><Square className='me-2' />Patient being treating by team?</div>
                    }
                </div>
                {/* <button className='col-12 col-xl-3 btn p-0 m-0' onClick={() => onRemove()} >No longer treating patient?</button> */}
                <button className='col-12 col-xl-1 btn p-0 m-0' onClick={_ => setShow(!show)} ><PeopleFill /></button>
            </div>
            <div className={`${show ? '' : 'd-none'}`}>
                <div style={{ position: 'sticky', top: '0px', background: '#ccc' }} className='shadow'>
                    <div className='text-center'>
                        <h3><People /> Team Members</h3>
                        <div>
                            {team.team.teamName}
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-xl-1'></div>
                        <div className='col-12 col-xl-2'><b>Who</b></div>
                        <div className='col-12 col-xl-2'><b>Status</b></div>
                        <div className='col-12 col-xl-2'><b>Started with team</b></div>
                        <div className='col-12 col-xl-2'><b>Last updated</b></div>
                        <div className='col-12 col-xl-2'><b>As</b></div>
                    </div>
                </div>
                {team.team.members && team.team.members.map(member =>
                    <div key={member.id} className='row' style={{ background: '#bbb' }}>
                        <div className='col-12 col-xl-1'>{member.currentStatus === 'Assigned' ? <PersonFill /> : <Person />}</div>
                        <div className='col-12 col-xl-2'>{member.user && member.user.firstName} {member.user && member.user.lastName}</div>
                        <div className='col-12 col-xl-2'>{member.currentStatus}</div>
                        <div className='col-12 col-xl-2'>{DateTimePickerFunctions.LocalISO(new Date(member.created.substring(0, 19)), 'h')}</div>
                        <div className='col-12 col-xl-2'>{DateTimePickerFunctions.LocalISO(new Date(member.lastUpdate.substring(0, 19)), 'h')}</div>
                        <div className='col-12 col-xl-2'>{member.role.role}</div>
                    </div>
                )}
            </div>
        </>
    )
}

// const AssignTo = ({ close, onAssign, team, setTeam }) => {
//     const { showError } = useContext(CommonFunctionsContext)
//     const [teams, setTeams] = useState([])
//     const teamRef = useRef()
//     // const _handleAssign = (e) => {
//     //     onAssign(teamRef.current.value)
//     //     close(() => { })
//     // }

//     useEffect(() => {
//         const load = async () => setTeams(await Team.GetFacilitiesTeams().catch(showError))
//         load()
//     }, [])

//     return (<div className='m-3 d-flex flex-column flex-grow-1'>
//         <div className='flex-grow-1'>
//             <label>Assign To</label>
//             <select
//                 onChange={e => setTeam(e.target.value)}
//                 ref={teamRef}
//                 placeholder='Team'
//                 className='form-control'>
//                 <option></option>
//                 {teams && teams.map(xTeam => <option selected={team === xTeam.id} value={xTeam.id} key={xTeam.id}>{xTeam.teamName}</option>)}

//             </select>
//         </div>
//         {/* <div className='text-center'>
//             <button onClick={_handleAssign} className='btn bg-primary-container'>Assign</button>
//         </div> */}
//     </div>)
// }